import { render, staticRenderFns } from "./vInput.vue?vue&type=template&id=2043ee69&scoped=true&"
import script from "./vInput.vue?vue&type=script&lang=js&"
export * from "./vInput.vue?vue&type=script&lang=js&"
import style0 from "./vInput.vue?vue&type=style&index=0&id=2043ee69&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043ee69",
  null
  
)

export default component.exports